import React from "react";
import Print from "../../../../assets/svg/btn_icons/print.svg";
function PrintExport({ handlePrintShow }) {
  return (
    <button
      type="button"
      className={`btn btn-soft-gray button-btn-label button-lg`}
      onClick={handlePrintShow}
      style={{ width: "max-content" }}
    >
      <img src={Print} alt="" className="export-btn-img" />
      <span className="font-size-14">PRINT</span>
    </button>
  );
}

export default PrintExport;
